import _ from 'lodash';
import Reveal from 'reveal.js';
import Markdown from 'reveal.js/plugin/markdown/markdown.esm';
import Highlight from 'reveal.js/plugin/highlight/highlight.esm';
import Notes from 'reveal.js/plugin/notes/notes.esm';
import config from 'Deck/config.json';
import Logo from './logo.svg'
import 'highlight.js/styles/github.css';
import 'reveal.js/dist/reveal.css';
import './style.scss';

function component() {
	const reveal = document.createElement('div');
	reveal.classList.add('reveal');
  const slides = document.createElement('slides');
	slides.classList.add('slides');
	const firstSlide = document.createElement('section');
	const title = document.createElement('h2');
	title.innerHTML = config.title;
	const subheader = document.createElement('p');
	subheader.innerHTML = _.join([config.speaker, config.eventdate], ' // ');
	const logo = new Image(300);
	logo.classList.add('logo');
	logo.src = Logo;
	firstSlide.appendChild(logo);
	firstSlide.appendChild(title);
	firstSlide.appendChild(subheader);
	slides.appendChild(firstSlide);
	if (config.twitter) {
		const twitter = document.createElement('div');
		twitter.classList.add('top');
		twitter.classList.add('left');
		twitter.innerHTML = config.twitter;
		reveal.appendChild(twitter);
	}
	const event = document.createElement('div');
	event.classList.add('top');
	event.classList.add('right');
	reveal.appendChild(event);
	if (config.eventlogo) {
		const eventlogo = new Image();
		eventlogo.src = config.eventlogo;
		event.appendChild(eventlogo);
	} else {
		event.innerHTML = config.event;
	}
	const section = document.createElement('section')
	for (var i in config.slides) {
		var slide = config.slides[i];
		var a = document.createElement('section');
		var type = slide.file.indexOf('.html') !== -1 ? 'html': 'markdown';
		a.setAttribute('data-' + type, 'deck/slides/' + slide.file);
		console.log(a);
		slides.appendChild(a);
	}
	slides.appendChild(section);
	reveal.appendChild(slides);
	return reveal;
}
document.body.appendChild(component());

const logosmall = new Image();
logosmall.classList.add('corner-logo');
logosmall.src = Logo;
document.body.appendChild(logosmall)

if (config.additionalScripts) {
	for (var i in config.additionalScripts) {
		var script = document.createElement('script');
		script.src = config.additionalScripts[i];
		script.type = "text/javascript";
		script.async = false;
		document.body.appendChild(script);
	}
}

if (config.additionalStyles) {
	for (var i in config.additionalStyles) {
		var style = document.createElement('link');
		style.rel = "stylesheet";
		style.href = config.additionalStyles[i];
		document.head.appendChild(style);
	}
}

let deck = new Reveal({
	hash: true,
	controls: true,
	progress: true,
	history: true,
	center: true,
	transition: 'fade', // none/fade/slide/convex/concave/zoom
	_backgroundTransition: 'fade',
	markdown: {
		smartypants: true
	},
	plugins: [ Markdown, Highlight, Notes]
})
deck.initialize();

var updateLogoVisibility = function (currentSlideIndex) {
	var logo = document.getElementsByClassName('corner-logo')[0];
	if (currentSlideIndex === 0) {
		logosmall.style.display = 'none';
	} else {
		logosmall.style.display = 'inline';
	}
};
updateLogoVisibility(0);
deck.addEventListener('ready', function (event) {
	updateLogoVisibility(event.indexh);
});
deck.addEventListener('slidechanged', function (event) {
	updateLogoVisibility(event.indexh);
});

if (config.reveal) {
	for (var i in config.reveal) {
		for (var k in config.reveal[i]) {
			deck.addEventListener(i, eval(config.reveal[i][k]));
		}
	}
}
